import React, { useEffect, useState } from 'react'
import api from './api'
import '../css/Sso.css'

import { useNavigate, useParams } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import { message, Avatar, Typography, Button, Badge, Result } from 'antd'

const { Title, Text, Link } = Typography

//  Cfx 互联 布局
function Sso(props) {
    const id = useParams()
    const navigate = useNavigate()
    const [data, setData] = useState(false)

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search)
        const code = searchParams.get('code')
        if (code) {
            api.post('/api/v2/apiv2', {
                name: 'getTppCallback',
                id: id.id,
                code: code,
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        message.success('已请求成功, 请尽快在游戏内确认已绑定!')
                        setData({ code: 200 })
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器 error: ' + error)
                })

            return
        }

        api.post('/api/v2/apiv2', {
            name: 'getwxqc',
            id: id.id,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    message.success('成功获取信息!')
                    console.log(res.data);
                    setData({ url: res.data.data.data.Data })
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器 error: ' + error)
            })
    }, [])


    if (!data) {
        return (
            <Result
                status="403"
                title="403"
                subTitle="此请求无法使用, 可能无效或过期以及已处理过, 请稍后重试!"
            />
        )
    }
    if (data && data.code === 200) {
        return (
            <Result
                title="OK"
                subTitle="已请求成功, 请尽快在游戏内确认已绑定!"
            />
        )
    }


    return (
        <Badge.Ribbon text="NZ Ban Cfx 网页认证">



            <div className='cfx'>
                <div className='avatar'>
                    <Avatar size={64} src={props.function.getAvatar()} />
                </div>
                <Title level={3} style={{ textAlign: 'center' }}>测试服</Title>

                <ul style={{ marginTop: 50, marginBottom: 50 }}>
                    <li><Text>将授权来自 <Link>FiveM平台</Link> 的服务器</Text></li>
                    <li><Text>本次授权为绑定 <Link>微信</Link> 权限, 将跳转第三方平台进行扫码验证</Text></li>
                    <li><Text>获取的数据将用于检验正常用户, 保护良好的体验环境, 不存在泄露个人隐私行为, 请求已做加密安全处理</Text></li>

                    {/* <li><Text>本次授权含有要求绑定 <Link>N2YUN社区账号</Link> 权限, 您需要登录本网站账户完成授权即可</Text></li> */}
                </ul>

                <Text type="secondary">声明: 所获取的数据是由第三方平台提供的特征ID, 且无法获取关于您的敏感、隐私等信息数据的, 如不放心授权可取消、终止本行为的。</Text>
                <Button type="primary" size='large' block onClick={() => {
                    const link = document.createElement('a')
                    link.href = data.url
                    link.click()
                }}>授权绑定</Button>
            </div>
        </Badge.Ribbon>


    )
}

export default Sso;